(async () => {
  // Skip federation initialization and go straight to bootstrap
  // This bypasses the Module Federation initialization that's causing issues
  await import("./bootstrap");
})();
